import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { TransitionPage } from './TransitionPage';

/**
 * Arche wrapper for DFE Inventory Transition — provides ArcheLayout with sidebar
 * and handles sub-routing.
 */
export function DfeInventoryTransitionArchePage() {
  return (
    <ArcheLayout>
      <Routes>
        <Route path="/" element={<TransitionPage />} />
      </Routes>
    </ArcheLayout>
  );
}
